<div
  class="position-relative"
  (click)="onClick()"
  [ngClass]="{ pointer: pointer }"
>
  @if (photo) {
    <img
      [src]="photo | secure | async"
      class="display-profile"
      [style.width.px]="size"
      [style.height.px]="size"
      [ngClass]="{ 'border-0': !borderColor }"
      [style.border-color]="borderColor || ''"
    />
  } @else {
    @switch (!!defaultPhoto) {
      @case (true) {
        <img
          class="display-profile"
          [src]="defaultPhoto"
          [style.border-radius]="'50%'"
          [style.width.px]="size"
          [style.height.px]="size"
          [ngClass]="{ 'border-0': !borderColor }"
          [style.border-color]="borderColor || ''"
        />
      }
      @default {
        <div
          class="display-profile"
          [style.width.px]="size"
          [style.height.px]="size"
          [style.font-size.px]="fontSize || size * 0.5"
          [style.background]="colorProfile"
          [style.border-color]="borderColor || colorProfile"
        >
          <span class="lh-normal">{{ initialName }}</span>
        </div>
      }
    }
  }
</div>
